import { render, staticRenderFns } from "./ItemButton.vue?vue&type=template&id=bdf977fc&"
import script from "./ItemButton.vue?vue&type=script&lang=ts&"
export * from "./ItemButton.vue?vue&type=script&lang=ts&"
import style0 from "./ItemButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports